import i from "react";
import { TextInput as y } from "../../TextInput/TextInput.js";
import { cls as O } from "../../../helpers/cls.js";
var w = Object.defineProperty,
  g = Object.defineProperties,
  E = Object.getOwnPropertyDescriptors,
  l = Object.getOwnPropertySymbols,
  m = Object.prototype.hasOwnProperty,
  s = Object.prototype.propertyIsEnumerable,
  d = (e, r, a) => r in e ? w(e, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: a
  }) : e[r] = a,
  I = (e, r) => {
    for (var a in r || (r = {})) m.call(r, a) && d(e, a, r[a]);
    if (l) for (var a of l(r)) s.call(r, a) && d(e, a, r[a]);
    return e;
  },
  j = (e, r) => g(e, E(r)),
  S = (e, r) => {
    var a = {};
    for (var t in e) m.call(e, t) && r.indexOf(t) < 0 && (a[t] = e[t]);
    if (e != null && l) for (var t of l(e)) r.indexOf(t) < 0 && s.call(e, t) && (a[t] = e[t]);
    return a;
  };
const _ = e => {
  var r = e,
    {
      elementId: a,
      label: t,
      placeholder: u,
      ariaExpanded: b,
      actionElement: n,
      isLoading: f,
      setSearchTerm: v,
      setShowItems: c,
      inputRef: h,
      searchTerm: x
    } = r,
    p = S(r, ["elementId", "label", "placeholder", "ariaExpanded", "actionElement", "isLoading", "setSearchTerm", "setShowItems", "inputRef", "searchTerm"]);
  return i.createElement("div", {
    id: "".concat(a, "-combobox"),
    "data-testid": "".concat(a, "-combobox")
  }, i.createElement(y, j(I({
    id: "".concat(a, "-input"),
    label: t != null ? t : "",
    "aria-autocomplete": "both",
    "aria-label": "Autocomplete",
    placeholder: u,
    role: "combobox",
    "aria-controls": "autocomplete-list",
    "aria-expanded": b,
    "aria-busy": p.state === "loading",
    onChange: o => {
      v(o.target.value), c(!0);
    },
    onKeyDown: o => {
      (o.key === "ArrowDown" || o.key === "ArrowUp") && c(!0);
    },
    ref: h,
    autoComplete: "off",
    value: x
  }, p), {
    className: O(n && "olx-autocomplete__input--action")
  })), n && !f && i.createElement("div", {
    className: "olx-autocomplete__action"
  }, n));
};
export { _ as Input };